import {AbstractControl, ValidatorFn} from "@angular/forms";

export class CustomValidators {
  static email(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      let pattern: RegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      if (control.value && !control.value.match(pattern)) {
        return {
          email: "true"
        };
      } else {
        return null;
      }
    }
  }

  static phone(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      let pattern: RegExp = /^(?:(?:\+|00)33[\s.-]{0,3}(?:\(0\)[\s.-]{0,3})?|0)[1-9](?:(?:[\s.-]?\d{2}){4}|\d{2}(?:[\s.-]?\d{3}){2})$/;
      if (control.value && !control.value.match(pattern)) {
        return {
          phone: "true"
        };
      } else {
        return null;
      }
    }
  }
}
